<template>
  <div>
    <top-bar :user="this.user" />
    <MenuItems :user="this.user" :menuSelected="{ manageUsers: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ manageUsers: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
      }">
        <h1>{{ $t("managementTitle") }}</h1>
        <p>{{ $t("managementShortDesc") }}</p>

        <div>
          <b-container fluid>
            <b-row class="border-box ">
              <b-col class="border-box p-0">
                <div class="account-title">
                  <h3 class="title-address-table">
                    <strong>{{ $t("inviteUserTitleSection") }}</strong>
                  </h3>
                  <!-- <p>{{ $t("inviteUserShortDesc") }}</p> -->
                  <br />
                </div>
              </b-col>
            </b-row>
            <b-row class="border-box content-delivery">
              <b-col class="border-box" xl="12" md="12">
                <form class="
                    add-user
                    d-flex
                    flex-column flex-md-row
                    align-items-center
                    
                  " @submit.prevent="
                    {
                      return false;
                    }
                  ">
                  <div style="width:40%">
                    <small>{{ $t("emailField") }}</small>
                    <input type="text" v-model="newUser.email" class="formedituser email" />
                  </div>
                  <div style="padding-left: 25px;">
                    <small>{{ $t("roleLabel") }}</small>
                    <b-form-radio-group id="lang" v-model="newUser.role" name="lang">
                      <b-form-radio value="1">
                        {{ $t("userModeLabel_1") }}</b-form-radio>
                      <b-form-radio value="2">
                        {{ $t("userModeLabel_2") }}</b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <a class="button-all button-orange m-0 min-width-100" @click="addNewUserForManageCompany()">{{
                    $t("addNewUserLabel")
                  }}</a>
                </form>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div>
          <h3 class="title-address-table">
            <strong>{{ $t("manageUsersTitleSection") }}</strong>
          </h3>
          <div v-for="(user, index) in usersForManageCompany" :key="index" class="content-delivery">
            <img class="personimg" :src="getImagePath() + 'users/user_' + user.person.id + '.png'"
              @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
            <div width="30%">
              <h5 class="h5-small">
                {{ user.person.first_name ? user.person.first_name + " " + user.person.last_name : user.username }}
              </h5>
              <p v-if="user.person.first_name && user.person.function && user.person.function.length > 0"
                class="p-small" v-html="
                  $t('activityDomain', {
                    domain: user.person.function,
                  })
                "></p>
              <p class="p-small" v-else-if="user.person.first_name"> &nbsp;</p>
            </div>
            <div><strong v-if="isUserPremium(user)" class="culoare-11"> {{ $t('userModeLabel_2') }}</strong>
              <strong v-else> {{ $t('userModeLabel_1') }}</strong>
            </div>
            <div v-if="user.companies[0].active">
              <a v-if="isUserPremium(user)" class="button-all button-black border-black"
                @click="switchModifyOrDeleteModalPopup('MODIFY', user, false)">{{ $t("downgradeFreeButtonLabel") }}</a>
              <a v-if="!userHasPremiumRequest(user) && !isUserPremium(user)" class="button-all button-orange"
                @click="switchModifyOrDeleteModalPopup('MODIFY', user, true)">{{ $t("upgradePremiumButtonLabel") }}</a>
              <a v-if="userHasPremiumRequest(user)" class="button-all button-orange"
                @click="switchModifyOrDeleteModalPopup('MODIFY', user, true)">{{
                  $t("approvePremiumButtonLabel")
                }}</a>
              <br v-if="userHasPremiumRequest(user)" />
              <a v-if="userHasPremiumRequest(user)" class="button-all button-red"
                @click="switchModifyOrDeleteModalPopup('MODIFY', user, false)">{{
                  $t("rejectPremiumButtonLabel")
                }}</a>
            </div>
            <div v-else style="min-width:220px; cursor: default;"><a class="button-all  button-grey border-black"
                style="cursor: default;">{{
                  $t("pendingButtonLabel")
                }}</a></div>
            <a @click="switchModifyOrDeleteModalPopup('DELETE', user)">
              <img src="@/assets/images/delete.svg" />
            </a>
          </div>

        </div>
      </div>
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p v-if="switchModifyOrDelete === 'MODIFY' && !this.premium">
          {{ $t("confirmModifyUserMessage") }}
        </p>
        <div v-if="switchModifyOrDelete === 'MODIFY' && this.premium">
          <div class="padding-50">
            <img src="@/assets/images/premium_popup.svg" />
            <h3>{{
              $t('confirmModifyAccount', { name: selectedUserForAction.person.first_name + ' ' +
                selectedUserForAction.person.last_name
            }) }}</h3>
            {{ $t("confirmModifyUserPremiumMessage") }}
          </div>
        </div>
        <p v-if="!switchModifyOrDelete === 'MODIFY'">{{ $t("confirmDeleteUserMessage") }}</p>
        <div class="buttons">
          <a v-if="switchModifyOrDelete === 'MODIFY'" href="#" class="yesButton" @click="modifyUserForManageCompany()">
            {{ $t("notificationsChooseOptionYes") }}
          </a>
          <a v-else href="#" class="yesButton" @click="deleteUsersForManageCompany()">
            {{ $t("notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="noChangeRole()">
            {{ $t("notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.userManageError">
          <p v-html="$t('error_' + this.userManageError.description)"></p>
        </div>
        <div v-else-if="addNewUserSuccess">
          <p>{{ $t("addUserInviteSuccessMessage") }}</p>
        </div>
        <div v-else-if="modifyUserSuccess">
          <p>{{ $t("modifyUserSuccessMessage") }}</p>
        </div>
        <div v-else-if="deleteUserSuccess">
          <p>{{ $t("deleteUserSuccessMessage") }}</p>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
  </div>
</template>

<script>
import httpServiceUser from "@/http/http-user.js";
import MenuItems from "../components/company/MenuItems.vue";
import TopBar from "../components/company/TopBar.vue";
import Cookies from "js-cookie";
import validator from "@/plugins/fieldValidation";

import {
  BFormRadio,
  BFormRadioGroup,
  BContainer,
  BRow,
  BCol,
} from "bootstrap-vue";
import ModalLoading from "../components/fragments/ModalLoading.vue";

export default {
  name: "ManageUsers",

  components: {
    "b-container": BContainer,
    "b-row": BRow,
    "b-col": BCol,
    "b-form-radio": BFormRadio,
    "b-form-radio-group": BFormRadioGroup,
    ModalLoading,
    TopBar,
    MenuItems,
  },
  data() {
    return {
      user: null,
      companyDataError: null,
      editMode: false,
      formData: null,
      usersForManageCompany: null,
      roles: ["USER"], //"MASTER" , "EDITOR"
      detailsMobile: false,
      userSelectedMobile: null,
      selectedUserForAction: null,
      beforeSelectedUserForChangeRole: null,
      premium: null,
      newUser: {
        email: "",
        role: "1",
      },
      userManageError: null,
      addNewUserSuccess: false,
      modifyUserSuccess: false,
      deleteUserSuccess: false,
      switchModifyOrDelete: "MODIFY", // false = Modify | true = Delete
    };
  },
  methods: {
    selectUserMobile(index) {
      this.userSelectedMobile = this.usersForManageCompany[index];
      this.detailsMobile = !this.detailsMobile;
    },
    noChangeRole() {
      // this.getUsersForManageCompany();
      this.showModalPopup("modal_popup_confirm", false);
    },
    beforeUserChangeRole(user) {
      this.beforeSelectedUserForChangeRole = user;
      // this.$forceUpdate();
    },
    addNewUserForManageCompany() {
      let error = false;
      if (this.newUser.email === "") {
        this.userManageError = {
          description: "EMAIL_EMPTY",
        };
        error = true;
      }
      if (!validator.validateEmail(this.newUser.email)) {
        this.userManageError = {
          description: "EMAIL_INVALID",
        };
        error = true
      }
      if (error) {
        this.showModalPopup("modal_popup_info", true);
        return;
      }
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      // this.showModalPopup("modal_popup_loading", true);

      httpServiceUser.userService
        .addNewUserForManageCompany(
          this.user.id,
          {
            email: this.newUser.email,
            flow: "add_user_company",
            company_role_id: this.newUser.role,
            company_code: this.user.companies[0].company_id
          },
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200) {
            this.addNewUserSuccess = true;
            this.newUser = {
              email: "",
              role: "1",
            },
              this.getUsersForManageCompany();
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.userManageError = { description: response.status };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    getUsersForManageCompany() {
      this.userManageError = null;

      httpServiceUser.userService
        .getUsersForManageCompany(
          this.user.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200) {
            this.usersForManageCompany = response.data;
          } else {
            this.userManageError = { description: response.status };
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          this.showModalPopup("modal_popup_info", true);
        });
    },
    modifyUserForManageCompany() {
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      this.selectedUserForAction.companies[0].role_id = this.premium ? 2 : 1;
      this.showModalPopup("modal_popup_confirm", false);
      // this.showModalPopup("modal_popup_loading", true);

      httpServiceUser.userService
        .modifyUserForManageCompany(
          this.user.id,
          this.selectedUserForAction.id,
          this.selectedUserForAction,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.modifyUserSuccess = true;
            this.getUsersForManageCompany();
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.userManageError = { description: response.status };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    deleteUsersForManageCompany() {
      this.addNewUserSuccess = false;
      this.modifyUserSuccess = false;
      this.deleteUserSuccess = false;
      this.userManageError = null;
      this.showModalPopup("modal_popup_confirm", false);
      // this.showModalPopup("modal_popup_loading", true);

      httpServiceUser.userService
        .deleteUsersForManageCompany(
          this.user.id,
          this.selectedUserForAction.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.deleteUserSuccess = true;
            this.getUsersForManageCompany();
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.userManageError = { description: response.status };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    switchModifyOrDeleteModalPopup(actionType, user, event = false) {
      this.switchModifyOrDelete = actionType;
      this.selectedUserForAction = user;
      this.premium = event;
      this.showModalPopup("modal_popup_confirm", true);
    },
    getFlows() {
      // this.userManageError = null;

      httpServiceUser.userService
        .getFlows(this.companyDetails.company_id, Cookies.get("token"))
        .then((response) => {
          if (response.status == 200) {
          } else {
            // this.userManageError = {description: response.status};
            // this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            // this.userManageError = {description: error.response.status};
          } else {
            // this.userManageError = {description: "undefined"};
          }
          // this.showModalPopup("modal_popup_info", true);
        });
    },
    userHasPremiumRequest(user) {
      return (
        user.companies[0].role_id === "5" || user.companies[0].role_id === 5
      );
    },
  },
  mounted() {
    this.getUsersForManageCompany();
  },
  computed: {},
  created() {
    this.user = this.getUser();

  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.content-delivery .personimg {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 20px;
}

.content-delivery div {
  /* margin: 20px; */
  min-width: 200px;
}

.custom-control {
  /* margin: 20px; */
  padding-left: 24px !important;
  min-width: 0px;
}

.resetButton:not([href]):not([tabindex]) {
  text-decoration: underline;
  color: #585858;
  font-style: italic;
  cursor: pointer;
}

select,
select.input-add-beneficiary {
  min-width: 80px;
}

.container-alb p {
  margin: 0 0 1rem;
}

.add-user {
  font-size: 13px;
}

.add-user>p {
  flex: 1 1 auto;
  margin: 10px;
}

.formedituser.email {
  min-width: 200px;
}

.min-width-100 {
  min-width: 100px;
}

@media (max-width: 767px) {
  .add-user>p {
    width: 100%;
  }
}
</style>
